// extracted by mini-css-extract-plugin
module.exports = {"section":"icons_section__25_h1","img":"icons_img__16Bue"};